<template>
  <div id="page404"
       class="error-content">
    <ipub-icon class="mar-b-100"
               style="font-size:230px;font-weight:400;line-height:160px"
               type="icona-404-error" />
    <div class="ipubw-h1 mar-b-50"
         style="font-size:130px">404 Error</div>
    <div class="ipubw-p2 mar-b-50"
         style="font-size:32px">This site cannot be reached.</div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main.js'
export default main
</script>
